<template>
  <div class="quiz-result">
    <div class="content columns">
      <div class="title-col column col-12">
        <div class="title title-col__title desktop-hidden">
          <span class="title-col__text">
            Realizująca marzenia
          </span>
        </div>
      </div>
      <div class="images-col column col-4 col-sm-12">
        <div class="thumbnail">
          <img :src="require('@/assets/images/pic-s5-realizujaca-marzenia.png')"
               alt="Segment" class=" img-responsive thumbnail-image" />
        </div>
      </div>
      <div class="description column">
        <div class="title title-col__title mobile-hidden">
          <span class="title-col__text">
            Realizująca marzenia
          </span>
        </div>
        <div class="description__content">
          <p class="quote">
            "Życie jest za krótkie na kompromisy"
          </p>
          <p>
            Nie wpisujesz się w schematy – bo tworzysz własne.
            Żyjesz po swojemu, nierzadko pod prąd, ale zawsze z sercem i intuicją jako kompasem.
            Dla Ciebie życie to podróż – nie obowiązek.
            Kochasz zmiany, odkrycia, bycie w ruchu, fizycznie i duchowo.
          </p>
          <p>
            Twoje wybory nie zawsze są zrozumiałe dla innych – ale są prawdziwe.
            Jesteś wolna, autentyczna, twórcza.
            Masz w sobie coś magnetycznego – lekkość, która nie oznacza lekkomyślności.
            Odwagę, która nie krzyczy, ale działa.
          </p>
          <p>
            W relacjach jesteś emocjonalna, ale niezależna.
            Potrzebujesz przestrzeni i zaufania, że możesz być sobą – bez kompromisów.
            Dajesz innym inspirację i pozwolenie, żeby też mogli chcieć „więcej”.
          </p>
          <p>
            Twoja supermoc? Żyjesz tak, jak wielu boi się nawet marzyć.
          </p>
          <p>
            <strong>Twoje wartości:</strong> wolność, autentyczność, pasja<br/>
            <strong>Styl życia:</strong> nieprzewidywalny, pełen symboli i znaczeń<br/>
            <strong>W relacjach:</strong> intensywna, serdeczna, ale potrzebująca przestrzeni<br/>
            <strong>Supermoc:</strong> inspirujesz innych do życia w zgodzie ze sobą
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RealizujacaMarzenia',
};
</script>

<style scoped>
.title-col__text {
  color: var(--color-realizujaca) !important;
}
.thumbnail-image {
  border-radius: 900px;
}
.quiz-result .percentage__value {
  color: var(--color-realizujaca);
}
.quiz-result .quote {
  font-style: italic;
  font-weight: 600;
  font-size: 22px;
}
</style>
